import { render, staticRenderFns } from "./Filtros.vue?vue&type=template&id=079b8ff8"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079b8ff8')) {
      api.createRecord('079b8ff8', component.options)
    } else {
      api.reload('079b8ff8', component.options)
    }
    module.hot.accept("./Filtros.vue?vue&type=template&id=079b8ff8", function () {
      api.rerender('079b8ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/auditorias/Filtros.vue"
export default component.exports